import { RouterPaths } from "../../app/appConstants";
import appHistory from "../../app/appHistory";
import { accountGetPortfolioSaga } from "../Account/accountSagas";
import { getBonusActiveGift50 } from "../Bonus/bonusesSelectors";
import { call, select, takeEvery } from "redux-saga/effects";
import { LOAD_MOBILE_BONUS_INFO_START } from "./mobileBonusConstants";

function* loadMobileBonusInfoSaga() {
    yield call(accountGetPortfolioSaga);
    const activeBonusGift50 = yield select(getBonusActiveGift50);
    if (activeBonusGift50?.status === 'active') {
        appHistory.push(RouterPaths.mobileGift50Bonus);
    } else {
        appHistory.push(RouterPaths.onboardingWelcome);
    }
}

export function* mobileBonusSagas() {
    yield takeEvery(LOAD_MOBILE_BONUS_INFO_START, loadMobileBonusInfoSaga);
}
